/**
 * @author Kelnik Studios {http://kelnik.ru}
 */

/**
 * Табы обычные, работают по data-tab и id
 */

import Utils from 'common/scripts/utils';

class TabBase {
    constructor() {
        this.targetSelector = '.j-base-tab';
    }

    init() {
        this._initElements();
        this._showContents();
        this._bindEvents();
    }

    _initElements() {
        this.targets = Array.from(document.querySelectorAll(this.targetSelector));
    }

    _bindEvents() {
        this.targets.forEach((target) => {
            target.addEventListener('click', this._clickTab.bind(this, target));
        });
    }

    _clickTab(target, event) {
        event.preventDefault();

        const groups = this._getGroups(target);

        this._toggleActive(target, groups);
        this._toggleContents(target, groups);
    }

    _getGroups(target) {
        const groupName = target.dataset.tabGroup;

        if (!groupName) {
            console.error('The target doesn`t have attribute "data-group"');

            return false;
        }

        return this.targets.filter((item) => {
            return item.dataset.tabGroup === groupName;
        });
    }

    _toggleActive(target, groups) {
        groups.forEach((item) => {
            const func = item === target ? 'add' : 'remove';

            item.classList[func]('is-active');
        });
    }

    _toggleContents(target, groups) {
        groups.forEach((item) => {
            if (!item.dataset.tab) {
                return;
            }

            const content = document.getElementById(item.dataset.tab);

            if (!content) {
                return;
            }

            Utils[target === item ? 'show' : 'hide'](content);
        });
    }

    _showContents() {
        this.targets.forEach((target) => {
            const isActive = Boolean(target.classList.contains('is-active'));

            if (!target.dataset.tab) {
                return;
            }

            const content = document.getElementById(target.dataset.tab);

            if (!content) {
                return;
            }

            Utils[isActive ? 'show' : 'hide'](content);
        });
    }
}

export default TabBase;
